export const kecGetSnap = 'step1/kecGetSnap';
//试用订单
export const kecTryOrder = 'step1/kecTryOrder';
export const QueryKecData = 'step1/QueryKecData';
export const kecRegions = 'step1/kecRegions';
export const kecImageList = 'step1/kecImageList';
export const kecDiyImage = 'step1/kecDiyImage';
export const kecSnapLimitNum = 'step1/kecSnapLimitNum';
export const kecQueryDisCount = 'step1/kecQueryDisCount';
export const kecCalcKvmPrice = 'step1/kecCalcKvmPrice';
export const calculateResPrice = 'step1/calculateResPrice';
export const QueryPriceSystem = 'step1/QueryPriceSystem';
export const getEbsSnap = 'step1/getEbsSnap';
export const describeMarketTAbList = 'step1/describeMarketTAbList';
export const describeMarketImage = 'step1/describeMarketImage';
export const QueryMaxBootNum = 'step1/QueryMaxBootNum';
export const DescribeModels = 'step1/DescribeModels';
export const GetInstanceByIds = 'step1/GetInstanceByIds';

export const queryCommonDiscount = 'step1/queryCommonDiscount';

export const batchCalculateKVMPrice = 'step1/batchCalculateKVMPrice';

export const GetQuota = 'step1/GetQuota';
export const QueryNetworkResource = 'step1/QueryNetworkResource';
export const DescribeSpotPriceHistory = 'step1/DescribeSpotPriceHistory';

export const checkSnapShotPermission = 'step1/checkSnapShotPermission';
export const openSnapShotService = 'step1/openSnapShotService';
export const DescribeSnapshotServiceStatus = 'step1/DescribeSnapshotServiceStatus';
export const DescribeInstanceGroupCount = 'step1/DescribeInstanceGroupCount';
export const DescribeEbsPerfQuotas = 'step1/DescribeEbsPerfQuotas';

// --以下为未登录constants--
export const noLoginQueryKecData = 'step1/noLoginQueryKecData';
export const noLoginkecImageList = 'step1/noLoginkecImageList';
export const noLoginKecQueryDisCount = 'step1/noLoginKecQueryDisCount';
export const noLoginQueryCommonDiscount = 'step1/noLoginQueryCommonDiscount';
// --以上为未登录constants--
